export default "__VITE_ASSET__B2EndgGP__"